import { Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationButtonState } from '../models/navigationButtonState';

interface SignupStep {
  label: string;
  link: string;
  state: NavigationButtonState;
}

@Component({
  selector: 'app-signup-stepper',
  templateUrl: './signup-stepper.component.html',
  styleUrls: ['./signup-stepper.component.css']
})
export class SignupStepperComponent {
  @Input() loginState: NavigationButtonState = 'inactive';
  @Input() venueState: NavigationButtonState = 'inactive';
  @Input() planState: NavigationButtonState = 'inactive';
  @Input() reviewState: NavigationButtonState = 'inactive';

  /** Mobile: show the condensed step header once the full stepper scrolls away. */
  condensed = false;

  constructor(private router: Router) {}

  get steps(): SignupStep[] {
    return [
      { label: 'Account', link: 'login', state: this.loginState },
      { label: 'Venue', link: 'venueType', state: this.venueState },
      { label: 'Plan', link: 'choosePlan', state: this.planState },
      { label: 'Review', link: 'review', state: this.reviewState }
    ];
  }

  get activeIndex(): number {
    const index = this.steps.findIndex(step => step.state === 'active');
    // No active step means every step is complete (confirmation page).
    return index === -1 ? this.steps.length - 1 : index;
  }

  get activeLabel(): string {
    return this.steps[this.activeIndex].label;
  }

  goTo(step: SignupStep): void {
    if (step.state !== 'inactive') {
      this.router.navigate([step.link]);
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.condensed = window.scrollY > 160;
  }
}
